'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SupportIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SupportIcon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={sx?.color ? sx.color : '#273443'}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 12C0.5 5.64886 5.64886 0.5 12 0.5C18.3511 0.5 23.5 5.64886 23.5 12C23.5 18.3511 18.3511 23.5 12 23.5C5.64886 23.5 0.5 18.3511 0.5 12ZM22.5 12C22.5 6.20114 17.7989 1.5 12 1.5C6.20114 1.5 1.5 6.20114 1.5 12C1.5 17.7989 6.20114 22.5 12 22.5C17.7989 22.5 22.5 17.7989 22.5 12ZM12 16.499L12.1018 16.5058C12.4678 16.5555 12.75 16.8694 12.75 17.249C12.75 17.6631 12.4141 17.999 12 17.999C11.5859 17.999 11.25 17.6631 11.25 17.249C11.25 16.8694 11.5322 16.5555 11.8982 16.5058L12 16.499ZM15.5 10.004C15.5 8.07154 13.9328 6.504 12 6.504C10.0675 6.504 8.5 8.07118 8.5 10.004C8.5 10.2801 8.72386 10.504 9 10.504C9.27614 10.504 9.5 10.2801 9.5 10.004C9.5 8.62351 10.6198 7.504 12 7.504C13.3805 7.504 14.5 8.62377 14.5 10.004C14.5 10.9979 13.9111 11.8971 13 12.2947L12.833 12.375C12.0177 12.805 11.5 13.6541 11.5 14.586V14.999L11.5081 15.0889C11.5504 15.3221 11.7545 15.499 12 15.499C12.2761 15.499 12.5 15.2751 12.5 14.999V14.586L12.5073 14.4382C12.5602 13.9017 12.8989 13.4298 13.3999 13.2113C14.6754 12.6546 15.5 11.3956 15.5 10.004Z"
        />
      </svg>
    </SvgIcon>
  )
}

SupportIcon.propTypes = {
  sx: PropTypes.object
}
